import { request } from '../request'
import { Industry } from '../types'

class IndustriesService {

  getAll(): Promise<Industry[]> {
    return request.get('/api/industries.json')
  }

}

export default IndustriesService
